import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { providerService } from '@/services/provider-service';
import type { Provider } from '@/types/core/provider';
import type { UUID } from '@/utils/uuid';

import { providerQueryKeys } from './query-keys';

/**
 * Find a specific provider by ID.
 * Returns a react-query query.
 */
export function useFindProvider(
  tenantId?: UUID,
  providerId?: UUID
): UseQueryResult<Provider | null, Error> {
  return useQuery<Provider | null, Error>({
    queryKey: providerQueryKeys.detail(tenantId, providerId),
    queryFn: async () => {
      if (!tenantId || !providerId) return null;
      return providerService.findProvider(tenantId, providerId);
    },
    enabled: !!tenantId && !!providerId,
  });
}
